export default "__VITE_ASSET__7356a5cc__"